<rk-card
  [name]="title"
  [hasError]="criteriaForm.invalid"
  (removeAction)="deleteCriteria.emit(index)"
>
  <ng-container [formGroup]="criteriaForm">
    <div class="criteria flex flex-col">
      <rk-dropdown-autocomplete
        [data]="generateOperatorsInput()"
        formControlName="operator"
      ></rk-dropdown-autocomplete>
      <rk-form-field *ngIf="!isBetweenInput(); else betweenInput">
        <input
          type="text"
          rkDaterangepicker
          readonly
          formControlName="value"
          [singleDatePicker]="true"
          [autoApply]="true"
        />
      </rk-form-field>
      <ng-template #betweenInput>
        <div class="flex flex-1">
          <rk-form-field class="playlist-criteria-date--between-field">
            <mat-icon
              class="playlist-criteria-date--between-icon"
              fontSet="fas"
              fontIcon="fa-calendar-alt"
            ></mat-icon>
            <input
              class="playlist-criteria-date--between-input"
              type="text"
              rkDaterangepicker
              readonly
              rkInput
              formControlName="betweenValue"
              [value]="formattedBetweenValue"
              [autoApply]="true"
              [updateInputValue]="false"
            />
          </rk-form-field>
        </div>
      </ng-template>
    </div>
  </ng-container>
</rk-card>
